module.exports = __webpack_public_path__ + "r-v3/img/ico_menu_show_arrow.bc6105a0.svg";